import generateBasicEntityActions from './generateBasicEntityActions';
import * as schemas from '../schemas';

const basicEntityActions = generateBasicEntityActions('assets');
const assetActions = {
  merge: (primaryId, secondaryId) => ({
    API_CALL: {
      httpMethod: 'PUT',
      endpoint: 'assets/merge',
      params: {
        id_primary: primaryId,
        id_secondary: secondaryId,
      },
    },
  }),
  fetchAllSimple: () => ({
    API_CALL: {
      httpMethod: 'GET',
      endpoint: 'simpleAssets',
      schema: { assets: [schemas.asset] },
    },
  }),
  destroyAll: params => ({
    API_CALL: {
      httpMethod: 'PUT',
      endpoint: 'assets/destroy_all',
      params,
    },
  }),

  ...basicEntityActions,
};

export default assetActions;
